import { NgModule } from '@angular/core';
import { MainLoginComponent} from "./components/main-login.component";
import { SignInComponent} from "./components/dummy/signIn.component";
import { PassRecoveryComponent} from "./components/dummy/pass-recovery.component";
import { EmailSentComponent} from "./components/dummy/email-sent.component";
import { CommonModule } from '@angular/common';
import { LoginRoutes } from './login.routes';
import { JsonpModule, HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AuthService } from '../../injections/auth.service'; 


@NgModule({
    imports: [CommonModule,
    LoginRoutes,
    JsonpModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpModule],
    exports: [],
    declarations: [MainLoginComponent, SignInComponent, PassRecoveryComponent,EmailSentComponent],
    providers: [AuthService],
})
export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/modules/login/login.module.ts